module.exports = __webpack_public_path__ + "img/a.974d51a6.jpg";